import React from "react";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import { FAQ_QUICK } from "@/lib/site";

/**
 * QuickFaq
 * The five highest-priority FAQ items pulled to the top of the buying
 * journey. Dark treatment, dense, editorial. Longer FAQ still lives
 * on /faq and inside the FaqSection block further down.
 */
export default function QuickFaq() {
  return (
    <section
      data-testid="quick-faq"
      className="relative bg-black text-white"
    >
      <div className="container-lw section-lw">
        <div className="grid gap-14 lg:grid-cols-[1fr_1.35fr] lg:gap-24">
          <div className="lg:sticky lg:top-28 lg:self-start">
            <div className="eyebrow text-[#0AB5FF]">
              <span className="h-1.5 w-1.5 rounded-full bg-[#0AB5FF]" />
              Answers before the call
            </div>
            <h2 className="mt-5 h-display text-4xl md:text-5xl lg:text-6xl">
              The five questions <br />
              <span className="text-gradient-lw">dealers actually ask.</span>
            </h2>
            <p className="mt-6 max-w-md text-[15px] leading-relaxed text-white/60">
              Longer FAQ available on the FAQ page. These are the five
              things every dealership principal asks first, answered
              directly.
            </p>
          </div>

          <Accordion type="single" collapsible className="w-full">
            {FAQ_QUICK.map((item, i) => (
              <AccordionItem
                key={i}
                value={`qfaq-${i}`}
                data-testid={`quick-faq-item-${i}`}
                className="border-b border-white/10"
              >
                <AccordionTrigger
                  data-testid={`quick-faq-trigger-${i}`}
                  className="py-6 text-left font-display text-lg font-semibold tracking-tight text-white hover:no-underline md:text-xl"
                >
                  <span className="flex items-baseline gap-5">
                    <span className="font-display text-xs font-semibold uppercase tracking-[0.22em] text-white/35">
                      {String(i + 1).padStart(2, "0")}
                    </span>
                    <span>{item.q}</span>
                  </span>
                </AccordionTrigger>
                <AccordionContent className="pb-6 pl-12 text-[15px] leading-relaxed text-white/70">
                  {item.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      </div>
    </section>
  );
}
